import { withRouter } from '01_core/components/system/CustomRouter';
import React from 'react';

/**
 * メニュー遷移で必ずリフレッシュするためのダミーコンテンツ
 */
class DummyContent extends React.Component {
  componentDidMount() {
    // メニュークリック時にクエリパラメータに渡された遷移先のURに遷移
    this.props.history.replace(this.props.location.search.replace('?', ''));
  }

  render() {
    return null;
  }
}

export default withRouter(DummyContent);
